// class ProductPrice extends HTMLElement{constructor(){super()}connectedCallback(){this.compare_price=this.querySelector(".product-price--compare"),this.price=this.querySelector(".product-price--original"),this.reference_unit=this.querySelector(".product-price--reference-unit"),this.reference_value=this.querySelector(".product-price--reference-value"),this.unit_price=this.querySelector(".product-price--unit-price"),this.unit_price_container=this.querySelector(".product-price--unit-container"),this.updatePriceListener()}disconnectedCallback(){window.off(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`)}updatePriceListener(){window.on(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`,({detail:{variant:e}})=>{this.updatePrices(e)})}updatePrices(e){e?(this.removeAttribute("style"),this.price.innerHTML=theme.utils.formatMoney(e.price),e.compare_at_price>e.price?(this.compare_price.innerHTML=theme.utils.formatMoney(e.compare_at_price),this.compare_price.style.display="inline-block"):this.compare_price.style.display="none",e.unit_price_measurement?(this.unit_price.innerHTML=theme.utils.formatMoney(e.unit_price),this.reference_unit.innerHTML=e.unit_price_measurement.reference_unit,1===e.unit_price_measurement.reference_value&&this.reference_value?this.reference_value.style.display="none":this.reference_value&&(this.reference_value.innerHTML=e.unit_price_measurement.reference_value,this.reference_value.style.display="block"),this.unit_price_container.style.display="flex"):this.unit_price_container.style.display="none"):this.style.display="none"}}const productPriceEl=customElements.get("product-price-root");productPriceEl||customElements.define("product-price-root",ProductPrice);

class ProductPrice extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.compare_price = this.querySelector(".product-price--compare"),
        this.price = this.querySelector(".product-price--original"),
        this.reference_unit = this.querySelector(".product-price--reference-unit"),
        this.reference_value = this.querySelector(".product-price--reference-value"),
        this.unit_price = this.querySelector(".product-price--unit-price"),
        this.unit_price_container = this.querySelector(".product-price--unit-container"),
        this.updatePriceListener()
    }
    disconnectedCallback() {
        window.off(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`)
    }
    updatePriceListener() {
        window.on(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`, ({detail: {variant: e}})=>{
            this.updatePrices(e)
        }
        )
    }
    updatePrices(e) {

           var Pid =e.id
          var WCP_JSON=[];
            if(document.getElementsByClassName('wcp_json_'+Pid).length){
              WCP_JSON=JSON.parse(document.getElementsByClassName('wcp_json_'+Pid)[0].innerText);
              for(var tempwcp=0; tempwcp < WCP_JSON.variants.length; tempwcp++){
              if(e.id==WCP_JSON.variants[tempwcp].id){
                e.price=WCP_JSON.variants[tempwcp].price;
                e.compare_at_price=WCP_JSON.variants[tempwcp].compare_at_price;
              }
              }
            }
			
            if (document.getElementsByClassName('wcp_vd_table').length != 0 && document.getElementById('vdtable') != null) {
              var source = document.getElementById('vdtable').innerHTML;
              var template = Handlebars.compile(source);
              if (document.getElementsByClassName('wcp_vd_table')[0] != undefined && document.getElementsByClassName('wcp_vd_table')[0].innerText != '') {
                var context = JSON.parse(document.getElementsByClassName('wcp_vd_table')[0].innerText);
                var vdtable = [];
                vdtable['vdtable'] = context['wpd_' + e.id];
                if(vdtable['vdtable']){
                vdtable['vdtable'].forEach(function (arrayItem) {
                  arrayItem.Price = arrayItem.Price.replace(/<\/?span[^>]*>/g, '');
                });
                }
                var html = template(vdtable);
				try{
					document.getElementById('wcp_vd_table').innerHTML = html;
				}catch(e){
					console.log("VD div not found");
				}
              }
              else {
			  try{
			    document.getElementById('wcp_vd_table').innerHTML = '';
			  }catch(e){
			  	console.log("VD div not found");
			  }
              }
            }
      
        e ? (this.removeAttribute("style"),
        this.price.innerHTML = theme.utils.formatMoney(e.price),
        e.compare_at_price > e.price ? (this.compare_price.innerHTML = theme.utils.formatMoney(e.compare_at_price),
        this.compare_price.style.display = "inline-block") : this.compare_price.style.display = "none",
        e.unit_price_measurement ? (this.unit_price.innerHTML = theme.utils.formatMoney(e.unit_price),
        this.reference_unit.innerHTML = e.unit_price_measurement.reference_unit,
        1 === e.unit_price_measurement.reference_value && this.reference_value ? this.reference_value.style.display = "none" : this.reference_value && (this.reference_value.innerHTML = e.unit_price_measurement.reference_value,
        this.reference_value.style.display = "block"),
        this.unit_price_container.style.display = "flex") : this.unit_price_container.style.display = "none") : this.style.display = "none"
    }
}
const productPriceEl = customElements.get("product-price-root");
productPriceEl || customElements.define("product-price-root", ProductPrice);
